import { createContext, useContext, useEffect, useState } from "react";
import { io } from "socket.io-client";
import { infoUser } from "../utils/auth";

import notifSound from "../audio/notif-ask-paiement.mp3"
import notifMsg from "../audio/notif-msg.mp3"
import notifConfirmPaid from "../audio/notif-confirm-paiement.mp3"

const SocketContext = createContext({
    socket: () => { },
    socketSport: () => { },
    messageReceived: Boolean, setMessageReceived: () => { },
    messageUser: Boolean, setMessageUser: () => { },
    notifAskPaiement: Boolean, setNotifAskPaiement: () => { },
    priceEmpire: { prices: [{ id: String, title: String, price: Number, discount: Number }], mode: Boolean }, setPriceEmpire: () => { },
    editJSON: (target, value, cb) => { },
    projectJson: { href: String, METHODPAY: {}, crypto_mm: String, method_pay: String, provider_pay: String },
    editDB: (socket, table, target, data, refreshUtils, cb) => { },
    getJSON: (socket) => { },
    messageUserSport: Boolean, setMessageUserSport: () => { }
});

export const SocketProvider = ({ children }) => {
    const [socket, setSocket] = useState(null);
    const [socketSport, setSocketSport] = useState(null)

    const [messageReceived, setMessageReceived] = useState(false)
    const [messageUser, setMessageUser] = useState(false)
    const [notifAskPaiement, setNotifAskPaiement] = useState(null)
    // demande de paiement d'une autre plateforme (PrimeStation…) : point sur « Paiements plateformes »
    const [notifPlatformPay, setNotifPlatformPay] = useState(null)
    const [priceEmpire, setPriceEmpire] = useState(null)

    const [messageUserSport, setMessageUserSport] = useState(null)

    const [projectJson, setProjectJson] = useState(null)

    const userToken = infoUser()

    const editJSON = (target, value, cb) => {
        if (socket && userToken) {
            socket.emit('empire_edit_json', { token: userToken.expecttoken, target, value }, (e) => {
                cb(e)
            })
        }
    }
    const editDB = (socket, table, target, data, refreshUtils, cb) => {
        if (socket && userToken) {
            socket.emit('empire_update_db', { token: userToken.expecttoken, nameAdmin: userToken.name, table, target, data, refreshUtils }, (e) => {
                cb && cb()
            })
        }
    }
    const getJSON = (socket) => {
        socket.emit('empire_get_json', { token: userToken.expecttoken }, (e) => {
            setProjectJson(e)
        })
    }

    console.log("ProjectJson",projectJson);
    
    useEffect(() => {
        const socketInstance = io(process.env.REACT_APP_PUBLIC_SOCKET_URL, {
            transports: ["websocket"]// Passer le projectId au serveur
        });
        setSocket(socketInstance);

        /** UNE DEMANDE DE PAIEMENT */
        socketInstance.on('notif_new_paiement', (e) => {
            setNotifAskPaiement(e)
            const audio = new Audio(notifSound);
            audio.play().catch(() => { });
        })
        socketInstance.on('notif_new_message', (e) => {
            setMessageUser(e)
            const audio = new Audio(notifMsg);
            audio.play().catch(() => { });
            /** GET MESSSAGE */
        })
        socketInstance.on('notif_confirm_paiement', (e) => {
            setNotifAskPaiement(e)
            const audio = new Audio(notifConfirmPaid);
            audio.play().catch((er) => {
                console.log(er);
            });
        })

        /** DEMANDE DE PAIEMENT D'UNE AUTRE PLATEFORME (PrimeStation…) */
        socketInstance.on('notif_platform_paiement', (e) => {
            setNotifPlatformPay(e)
            const audio = new Audio(notifSound);
            audio.play().catch(() => { });
        })

        socketInstance.on('message_send', () => {
            setMessageReceived(true)
        })

        socketInstance.on("connect", () => {
            console.log("🔌 Socket !");
            socketInstance.emit('empire_tracker_connect', { token: userToken.expecttoken, name: userToken.name }, (e) => {
                console.log(e);
            })
            socketInstance.emit('empire_price', {}, (e) => {
                setPriceEmpire(e)
            })
            getJSON(socketInstance)
        });
        socketInstance.on("disconnect", () => {
            console.log("❌ Socket");
        });
        return () => {
            socketInstance.disconnect();
        };
    }, []);

    useEffect(() => {
        /*const socketInstanceSport = io(process.env.REACT_APP_SPORT_SOCKET_URL + "/_empSpo", {
            transports: ["websocket"],
            query: {
                token: userToken.expecttoken
            }
        });

        socketInstanceSport.on("connect", () => {
            setSocketSport(socketInstanceSport)
        });

        return () => {
            socketInstanceSport.disconnect();
        };*/
    }, [])

    return (
        <SocketContext.Provider value={{
            socket,
            socketSport,
            messageReceived, setMessageReceived,
            messageUser, setMessageUser,
            messageUserSport, setMessageUserSport,
            notifAskPaiement, setNotifAskPaiement,
            notifPlatformPay, setNotifPlatformPay,
            priceEmpire, setPriceEmpire,
            editJSON,
            editDB,
            projectJson,
            getJSON
        }}>

            {children}

        </SocketContext.Provider>
    );
};

export const useSocket = () => {
    return useContext(SocketContext);
};
